import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
//import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { NumberFormatter } from '../components/numberFormatter';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';
import Cookies from 'js-cookie';
import { GetAgoTime } from '../components/getAgoTime';
//help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { VscVerifiedFilled } from "react-icons/vsc";
import { MdDone } from 'react-icons/md';
//page links  
import { Randomcode } from '../components/rendom_code';
import { useToast } from '../components/ToastContext';
import { VscCalendar } from "react-icons/vsc";
import Photosicon from '../assets/photos_icon.png';
import { FaStar } from "react-icons/fa";
import './user-profile.css';
import { Savesubscriber } from '../profile_root/Save_subscriber';
import Statusbar from '../master_root/statusbar';
import { MdSend } from 'react-icons/md';
import { Savemessagesystem } from '../messaging_root/save_messagesystem';
import PhoneCodeList from '../components/PhoneCodeList';
export default function Userprofile({ data = {} }) {
  const location = useLocation();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [usersdetailsdata, setUsersdetailsdata] = useState([]);
  const [skilsdetailsData, setskilsdetailsData] = useState([]);
  const [subjact, setSubjact] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [selectedCode, setSelectedCode] = useState(null);
  const [countryname, setSelectedcountryname] = useState(null);
 
  const [loading, setLoading] = useState(true);
  const [Selected, setSelected] = useState('Overview');
  const [usersubscriber, setusersubscriber] = useState(data.subscriber);
  const [yousubscribed, setyousubscribed] = useState(false);
  const [Pagetitle, setPagetitleData] = useState('Find the Right Job or Talent Faster');
  const [Pagedescription, setPagedescriptionData] = useState(
    'Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers.'
  );

  useEffect(() => {
    fetch_skils_details();
    fetchdetails();
    if (data.name) {
      setPagetitleData(data.name + " | " + data.bio);
    }
    if (data.bio) {
      setPagedescriptionData(data.bio);
    }
    you_subscribed();
  }, [data]); // ✅ Added dependency array

  const handleChange = (selectedOption) => {
    setSelectedCode(selectedOption);
    const countryName = selectedOption.label.split(" (")[0];
    setSelectedCode(selectedOption.value);
    setSelectedcountryname(countryName);
 
  };

  const fetch_skils_details = async () => {

    try {
      const userQuery = query(
        collection(db, "skils_details"),
        where("guid", "==", data.guid)
      );
      const userSnapshot = await getDocs(userQuery);

      const usersData = userSnapshot.docs.map((userDoc) => ({
        uid: userDoc.id,
        ...userDoc.data()
      }));

      //
      setskilsdetailsData(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchdetails = async () => {

    try {
      const userQuery = query(
        collection(db, "users_details"),
        where("guid", "==", data.guid)
      );
      const userSnapshot = await getDocs(userQuery);

      const usersData = userSnapshot.docs.map((userDoc) => ({
        uid: userDoc.id,
        ...userDoc.data(),
      }));

      setUsersdetailsdata(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  //Savesubscriber
  const post_Savesubscriber = async (e) => {
    if (!data.uid) {
      showToast("User ID missing");
      return;
    }
    const result = await Savesubscriber({
      uid: Randomcode(15),
      userguid: data.guid,
      subscriber: usersubscriber,
    });

    if (result.success && result.removed) {
      // Like removed → decrement
      setTimeout(() => {
        setusersubscriber((prev) => Math.max(0, prev - 1));
        setyousubscribed(false);
      }, 1000);
    } else if (result.success && result.saved) {
      // Like added → increment
      setTimeout(() => {
        setusersubscriber((prev) => prev + 1);
        showToast("Congratulations");
        setyousubscribed(true);
      }, 1000);
    } else {
      showToast("Failed to publish");
    }
  };

  const you_subscribed = async () => {
    const guid = Cookies.get("guid");
    // Safety check
    if (!data?.guid || !guid) {
      console.error("Missing userguid or guid");
      setyousubscribed(false);
      return;
    }

    const subQuery = query(
      collection(db, "subscriber"),
      where("userguid", "==", data.guid),
      where("guid", "==", guid)
    );

    try {
      const subscriberSnapshot = await getDocs(subQuery);
      if (!subscriberSnapshot.empty) {
        setyousubscribed(true);
      } else {
        setyousubscribed(false);
      }
    } catch (error) {
    
      setyousubscribed(false);
    }
  };
  const submit_contacts = async () => {
    if (!countryname || !subjact || !phone || !message) {
      return;
    }
    setLoading(true);
    try {
      // Generate a random UID
      const uid = Randomcode(12);
      // Await the result of saving the message
      const result = await Savemessagesystem({
        uid,
        phonecountry: countryname,
        phonecodes: selectedCode.replace("+", ""),
        phone: selectedCode.replace("+", "") + phone,
        subjact,
        accountguid: data.guid,
        category: "contact",
        message: message,
      });

      if (result.success) {
        showToast("Sent successfully");
        
      } else {
        const errorMessage = result.error || "Unknown error";
        showToast("Failed: " + errorMessage);
    
      }
    } catch (ex) {
      console.error("An error occurred:", ex); 
    } finally {
      setLoading(false);
    }
  };

//
const [feedsData, setFeedsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
useEffect(() => {
  if (Selected === 'feed') {
    fetchsetFeedsData();
  }
}, [Selected]); 
  const fetchsetFeedsData = async () => {
    try {
      const feedsQuery = query(
        collection(db, "feeddata"),
         where("guid", "==",data.guid),
        where("public", "==", true),
        where("status", "==", true)
      );
      const feedsSnapshot = await getDocs(feedsQuery);
 
         
        
      const dataList = await Promise.all(
        feedsSnapshot.docs.map(async (doc) => {
          const feedData = { id: doc.id, ...doc.data() };

          const detailsQuery = query(
            collection(db, "users"),
            where("guid", "==", feedData.guid)
          );

          const detailsSnapshot = await getDocs(detailsQuery);
          const userData =
            detailsSnapshot.docs.map((detailsDoc) => ({
              uid: detailsDoc.id,
              ...detailsDoc.data(),
            }))[0] || null;

          return {
            ...feedData, // fixed from feedData to usersData
            userData: userData,
          };
        })
      );

      setFeedsData(dataList);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <div>
      <Statusbar data={'Account Profile'} />
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>{Pagetitle} | EditorTask - Find the Right Job or Talent Faster</title>

          <meta name="description" content={Pagedescription} />
          <meta
            name="keywords"
            content={`${Pagedescription}, job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work`}
          />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta
            property="og:title"
            content={`${Pagetitle} | EditorTask - Find the Right Job or Talent Faster`}
          />
          <meta property="og:description" content={Pagedescription} />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={typeof window !== 'undefined' ? window.location.href : 'https://www.editortask.com/'}
          />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
        </Helmet>

        <div className='user-covers-body'>
          {loading && <div className="loading"><Lodinging /></div>}
          <img
            className="user-covers-img"
            src={data.cover}
            alt="cover"
            onLoad={() => setLoading(false)}
            onError={() => setLoading(false)} // also hides loader if there's an error
            style={{ display: loading ? 'none' : 'block' }} // hide img while loading
          />
        </div>
        <div className='user-profile-body'>
          <div className="container_size">
            <div className='post-container'>
              <div className='profile-logo-div' >
                {loading && <div className="loading"><Lodinging /></div>}
                <img
                  className="user-profile-photo"
                  src={data.photoURL}
                  alt="User"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = Photosicon;
                  }}
                />

              </div>

              <div className='post_div'>
                <br />
                <div>
                  <div className='user-profile-name-div'>
                    <table>
                      <tr>
                        <td><div className="name-text">{data.name}</div></td>
                        <td>  {
                          data.verification ? (
                            <div className='Virfied-div'  >
                              <VscVerifiedFilled className='virfied-img' />
                            </div>
                          ) : (
                            <div className='Virfied-div' title='Managed by employer'>
                              <MdDone className='unvirfied-img' />
                            </div>
                          )
                        }</td>
                      </tr>
                    </table>

                    <div className="rating-div"><FaStar className='items-rating' />{data.rating + "  |  " + data.reviws + " reviews"}</div>
                  </div>
                  <div onClick={post_Savesubscriber} className="button-ui">
                    {usersubscriber}
                    <div className="subscriber-text">
                      {yousubscribed ? "Subscribed" : "Subscribe"}
                    </div>
                  </div>


                </div>

                <div className='industry-grid'>
                  {data.industry && (
                    <div className="industry-grid">
                      {data.industry.split(',').map((item, index) => (
                        <div key={index} className="industry-items">
                          {item.trim()}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>


            </div>
          </div>
        </div>
        <div className="container_size">

          <div className='tabs-body'>
            <div
              onClick={() => setSelected('Overview')}
              className={`tabsbutton ${Selected === 'Overview' ? 'active' : ''}`}
              title="Overview"
            >
              <span className="tabs-text">Overview</span>
            </div>
            <div
              onClick={() => setSelected('feed')}
              className={`tabsbutton ${Selected === 'feed' ? 'active' : ''}`}
              title="Feed"
            >
              <span className="tabs-text">Feed</span>
            </div>
            <div
              onClick={() => setSelected('Contactus')}
              className={`tabsbutton ${Selected === 'Contactus' ? 'active' : ''}`}
              title="Contact Us"
            >
              <span className="tabs-text">Contact Us</span>
            </div>

          </div>
          <div>

            {Selected === 'Overview' ? (
              <>
              <br/>
                <div className='overview-body-div'>
                  {/* Profile Summary */}
                  {data.bio && data.bio.length > 0 && (
                    <div className='overview-bio-div'>
                      <b>Bio</b><br />
                      <div>{data.bio}</div>
                    </div>
                  )}
                  <table className='editor-table' >
                    <tr><td>
                      <VscCalendar className='icon' />
                    </td>
                      <td className='iteme-text'>
                        {`Join:  ${GetAgoTime(data.datetime)} `}
                      </td>
                    </tr>

                  </table>
                </div>
                {usersdetailsdata.some(user => user.details === "profile_summary") && (
                  <div className='overview-body-div'>
                    <table width={`100%`}>
                      <tr>
                        <th>Profile summary</th>
                        <th>Details</th>
                      </tr>
                      <tbody>
                        {usersdetailsdata
                          .filter(user => user.details === "profile_summary")
                          .map((user, index) => (
                            <React.Fragment key={`profile_summary-${index}`}>
                              <tr>
                                <td><b>{user.title}</b></td>
                                <td>{user.value}</td>
                              </tr>

                            </React.Fragment>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* overview-body-div */}

                {skilsdetailsData.length > 0 ? (
                  <div className='overview-body-div'>
                    <table>
                      <tbody>
                        {skilsdetailsData.map((user, index) => (
                          <React.Fragment key={`skill-${index}`}>
                            <tr>
                              <td>
                                <b>{user.jobCategories}</b>
                              </td>
                            </tr>
                            <tr>
                              <td >
                                {user.description}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <></>
                )}

                {/* education */}
                {usersdetailsdata.some(user => user.details === "education") && (
                  <div className='overview-body-div'>
                    <table width={`100%`}>
                      <tr>
                        <th>Education</th>
                        <th>Institution</th>
                        <th>Marks</th>
                        <th>Year</th>
                      </tr>
                      <tbody>
                        {usersdetailsdata
                          .filter(user => user.details === "education")
                          .map((user, index) => (
                            <React.Fragment key={`education-${index}`}>
                              <tr>
                                <td><b>{user.title}</b></td>
                                <td>{user.value}</td>
                                <td>{user.marks}%</td>
                                <td>{user.year}</td>
                              </tr>
                              <tr>
                                <td >{user.description}</td>
                              </tr>
                            </React.Fragment>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {/* projects*/}
                {usersdetailsdata.some(user => user.details === "projects") && (
                  <div className='overview-body-div'>
                    <table width={`100%`}>
                      <tr>
                        <th>Projects</th>
                        <th>Details</th>
                      </tr>
                      <tbody>
                        {usersdetailsdata
                          .filter(user => user.details === "projects")
                          .map((user, index) => (
                            <React.Fragment key={`projects-${index}`}>
                              <tr>
                                <td><b>{user.title}</b></td>
                                <td>{user.value}</td>
                              </tr>

                            </React.Fragment>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}

              </>

            ) : Selected === 'feed' ? (
             <>
             <br/>
                   <div className='feedsUI-grid'>
                {isLoading ? (
                  <Loadingimg />
                ) : feedsData.length === 0 ? (
                  <p>No feeds available.</p>
                ) : (
                  feedsData.map((feeds) => (
                    <div className="feeds-items" onClick={() => navigate('/'+feeds.slug)} key={feeds.id}>
                      <div className="photo-ui-body">
                        <img className="photo-ui-img" src={feeds.file_url} alt="Feed" />
                      </div>
                      <div className='info-div'>
                        <div className='title-text'>{feeds.title.substring(0, 50)}</div>
                        <div className='info-body'>
                          <div className='feed-ui-photo-div'>
                            {feeds.file_url ? (
                              <img src={feeds.userData.photoURL} className='photo-img' />
                            ) : (
                              <Loadingimg />
                              
                            )}
                          </div>
                          <div className='feed-name-div'>
                            <table>
                              <tr><div className='name-text'>{feeds.userData.name.substring(0, 30)}</div></tr>
                              <tr><div className='subscriber-text'>{feeds.userData.subscriber} Subscriber</div>
                              </tr>
                            </table>
                          </div>
                          <div className='view-div'>
                            <div className='view-text'>{NumberFormatter(feeds.views)} Views</div>
                                   <div className='view-text'>{NumberFormatter(feeds.like)} Like</div>
                            <div className='date-text'>{GetAgoTime(feeds.date_time)}</div>

                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              </>
            ) : Selected === 'Contactus' ? (
              <table className='contacts-table'>
                 <br/>
                <tr><td>

                  <PhoneCodeList
                    options={selectedCode}
                    placeholder="Select country code"
                    onChange={handleChange}
                  />

                </td>
                </tr>
                <tr><td>
                  <input
                    id='phone-input'
                    className="message-input"
                    maxLength={20}
                    value={phone}
                    onChange={(e) => {
                      const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                      setPhone(onlyNums);
                    }}
                    placeholder="Enter Mobile number"
                  /> </td></tr>
                <tr><td>

                  <input className='message-input' maxLength={50} value={subjact} onChange={(e) => setSubjact(e.target.value)} placeholder='Enter Subjact'></input>
                </td></tr>
                <tr><td>

                  <textarea rows='6' className='message-input' maxLength={500} value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Enter Message'></textarea>
                </td></tr>
                <tr><td>

                  <div >
                    <div className='button-ui' onClick={submit_contacts} >
                      {loading ? <Loadingimg /> : <MdSend className='icon' />}
                      Submit</div>
                  </div>


                </td></tr>
              </table>
            ) :
              (
                <div>No section selected</div>
              )}
          </div>

        </div>
      </div>
      <br />  <br />
    </div>
  );
}
